const resolveServerUri = () => {
  if (process.env.GATSBY_API_URL) return process.env.GATSBY_API_URL;
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return "http://localhost:1337";
    if (host.includes("icy-mud") || host.includes("kind-plant")) return "https://shift-cms-dev.ironbit.net";
  }
  return "https://cms.shiftmexico.com";
};

const serverUri = resolveServerUri();

export { serverUri };
